import logo from './logo.svg';
import './App.css';

import Gallery from './components/Gallery';

function App() {
  return (
    <div className="App">
      <h1 className = "photogallery">Image Gallery</h1>
     <Gallery/>
    </div>
  );
}

export default App;



